import { SendNextStep } from 'components-machine';
import { ForbiddenError, UnauthorizedError } from 'src/auth';
import { getTokenFromStorageOrFail } from 'src/contexts/errorTrackingContext';

export const sendNextStep: SendNextStep = async ({ poll, state }) => {
  const { revision, wave } = poll;
  const queryParams = new URLSearchParams({ poll_id: poll.id });

  if (revision != null) queryParams.append('revision', String(revision));
  if (wave != null) queryParams.append('wave', String(wave));

  const headers: HeadersInit = { 'Content-Type': 'application/json' };
  try {
    const authStep = poll.questions.find(q => q.data.type === 'POLL_AUTH');
    const foundStepInState = authStep && state.answersStack.find(answerState => answerState.id === authStep?.id);

    if (foundStepInState) {
      const token = getTokenFromStorageOrFail();
      if (token.accessToken?.value) {
        headers['Authorization'] = `Bearer ${token.accessToken.value}`;
      }
    }
  } catch {
    /* empty */
  }

  const res = await fetch(`${window.APP_POLL_SERVER_REDUCER}/nextStep?${queryParams.toString()}`, {
    body: JSON.stringify(state),
    credentials: 'same-origin',
    method: 'POST',
    headers,
  });

  if (res.status === 401) {
    throw new UnauthorizedError('Unauthorized');
  }
  if (res.status === 403) {
    throw new ForbiddenError('Forbidden');
  }

  return await res.json();
};
